import Component from '@glimmer/component';
import { service } from '@ember/service';
import { trackedFunction } from 'reactiveweb/function';
import type Store from '@ember-data/store';
import type { ApplicationApprovalSummaryApprover } from '../../../types/tuition-assistance.ts';
import { eq } from 'tio-ui/utilities';
import { LinkTo } from '@ember/routing';
import { concat } from '@ember/helper';
import { t } from 'ember-intl';

export interface TuitionAssistanceApplicationDetailsApproverQueueEmployeeInfoSignature {
  Args: {
    consumingApp: string;
    reviewer: ApplicationApprovalSummaryApprover;
    cellClass: string;
  };
}

export default class TuitionAssistanceApplicationDetailsApproverQueueEmployeeInfoComponent extends Component<TuitionAssistanceApplicationDetailsApproverQueueEmployeeInfoSignature> {
  @service declare store: Store;

  employeeState = trackedFunction(this, async () => {
    const { employee_id } = this.args.reviewer;

    if (!employee_id) {
      return;
    }

    const employee = await this.store.findRecord('employee', employee_id, {
      include: 'person',
    });

    return employee;
  });

  get employeeFullName() {
    // @ts-expect-error: does this actually work?
    const employee = this.employeeState.value?.fullName;

    return employee ? employee : this.args.reviewer.employee_id;
  }

  get employeePersonId() {
    // @ts-expect-error: does this actually work?
    return this.employeeState.value?.person?.id;
  }

  <template>
    {{#if (eq @reviewer.dot "TAS.Approver.TIO_APPROVER")}}
      <td class={{@cellClass}} colspan="2">
        {{t (concat "tuition_assistance.approval_queue.roles." @reviewer.dot)}}
      </td>
    {{else}}
      <td class={{@cellClass}}>
        {{#if (eq @consumingApp "tio-admin")}}
          <LinkTo
            @route="authenticated.people.show"
            @model={{this.employeePersonId}}
            class="tio-copy"
          >
            {{this.employeeFullName}}
          </LinkTo>
        {{else}}
          {{this.employeeFullName}}
        {{/if}}
      </td>
      <td class={{@cellClass}}>
        {{t (concat "tuition_assistance.approval_queue.roles." @reviewer.dot)}}
      </td>
    {{/if}}
  </template>
}
